import axiosInstance from "../../config/axiosInstance";

export default async function getUploadedDocument(documentUrl) {
  return await axiosInstance.dillApi().get("/operations/" + documentUrl);
}
